import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumAccesses({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M324.794 236.314C324.794 229.186 333.411 225.618 338.451 230.657L437.931 330.137C441.055 333.261 441.055 338.327 437.931 341.451L338.451 440.931C333.412 445.97 324.794 442.402 324.794 435.275V372H120C113.373 372 108 366.627 108 360V312C108 305.373 113.373 300 120 300H324.794V236.314Z"
        fill="#57D7D9"
      />
      <path
        d="M156 168C156 154.745 166.745 144 180 144V168H156Z"
        fill="white"
      />
      <path
        d="M516.898 144C530.153 144 540.898 154.745 540.898 168H516.898V144Z"
        fill="white"
      />
      <path
        d="M156 504H180V528C166.745 528 156 517.255 156 504Z"
        fill="white"
      />
      <path
        d="M516.898 528V504H540.898C540.898 517.255 530.153 528 516.898 528Z"
        fill="white"
      />
      <path d="M180 144H517V168H180V144Z" fill="white" />
      <path d="M180 504H517V528H180V504Z" fill="white" />
      <path
        d="M156 404C156 399.582 159.582 396 164 396H172C176.418 396 180 399.582 180 404V504H156V404Z"
        fill="white"
      />
      <path
        d="M180 268C180 272.418 176.419 276 172 276H164C159.582 276 156 272.418 156 268L156 168H180L180 268Z"
        fill="white"
      />
      <path d="M517 168H541V504H517V168Z" fill="white" />
    </svg>
  );
}
